import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        form: '=',
        isReadOnly: '<'
    },
    template: `
        <div class="block01">
            <div class="heading01 heading01b">
                <h3>{{ "planningGroup.Targets" | translate }}</h3>
                <a class="btn add" ng-if="!vm.isReadOnly" ng-click="vm.manageTarget(null)">{{ "planningGroup.Add target" | translate }}</a>
            </div>
            <div class="tablewrapper">
                <list-empty list="vm.defaultTargets" show-add-message="true"></list-empty>
                <table ng-if="vm.form.model.targets.length"
                    class="data01"
                    datatable
                    dt-options="vm.DATATABLES">
                    <thead>
                        <tr role="row">
                            <th>{{ "planningGroup.Department" | translate }}</th>
                            <th>{{ "planningGroup.Role" | translate }}</th>
                            <th>{{ "planningGroup.Level" | translate }}</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr ng-repeat="target in vm.defaultTargets" role="row" class="odd">
                            <td>
                                <span ng-if="target.departmentName">{{ target.departmentName }}</span>
                                <span ng-if="!target.departmentName">{{ 'planningGroup.All departments' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="target.roleName">{{ target.roleName }}</span>
                                <span ng-if="!target.roleName">{{ 'planningGroup.All roles' | translate }}</span>
                            </td>
                            <td>
                                <span ng-if="target.levelName">{{ target.levelName }}</span>
                                <span ng-if="!target.levelName">{{ 'planningGroup.All levels' | translate }}</span>
                            </td>
                            <td class="actions">
                                <a class="btn edit"
                                    ng-if="!vm.isReadOnly"
                                    ng-click="vm.manageTarget(target.id)"
                                >{{ 'general.Edit' | translate }}</a>
                                <a class="btn delete"
                                    ng-if="!vm.isReadOnly"
                                    ng-click="vm.removeTarget(target.id)"
                                >{{ 'general.Remove' | translate }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" class="block01">
            <div class="heading01 heading01b">
                <h3>{{ 'planningGroup.Exceptions' | translate }}</h3>
                <a class="btn add" ng-if="!vm.isReadOnly" ng-click="vm.addExceptionTarget()">{{ "planningGroup.Add rule" | translate }}</a>
            </div>
            <div class="tablewrapper">
                <list-empty list="vm.exceptionTargets" show-add-message="true"></list-empty>
                <table class="data01 col-4" datatable dt-options="vm.DATATABLES" ng-if="vm.exceptionTargets.length">
                    <thead>
                    <tr>
                        <th>{{ 'employee.First Name' | translate }}</th>
                        <th>{{ 'employee.Last Name' | translate }}</th>
                        <th>{{ 'employee.Position' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="target in vm.exceptionTargets">
                        <td>{{ target.user.firstName }}</td>
                        <td>{{ target.user.lastName }}</td>
                        <td>
                            <p ng-repeat="employeeDrl in target.user.drlsWithValue">
                                {{ employeeDrl.departmentName }}, {{ employeeDrl.roleName }}, {{ employeeDrl.levelName }}
                            </p>
                        </td>
                        <td class="actions">
                            <a class="btn delete"
                                ng-if="!vm.isReadOnly"
                                ng-click="vm.removeTarget(target.id, true)"
                            >{{ 'general.Remove' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, toastr, lodash, CourseResource, ClassifierResource, AutomatedPlanningGroupResource,
                 ModalService, TokenService, DATATABLES, CLASSIFIER_ENUM, COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM) {
        this.$translate = $translate;
        this.toastr = toastr;
        this.lodash = lodash;
        this.DATATABLES = DATATABLES;
        this.CourseResource = CourseResource;
        this.ClassifierResource = ClassifierResource;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
        this.ModalService = ModalService;
        this.TokenService = TokenService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
    }

    $onInit () {
        this.departments = [];
        this.roles = [];
        this.levels = [];

        this.loadDefaultTargets();
        this.loadExceptionTargets();

        this.CourseResource.get({ id: this.form.model.courseId, expand: 'courseTargetsWithValue' })
            .$promise
            .then((course) => {
                this.loadCourseDefaultTargets(course);
                this.loadCourseExceptionTargets(course);
            });
    }

    reloadPlanningGroup () {
        this.AutomatedPlanningGroupResource.get({
            id: this.planningGroup.id,
            expand: 'planningGroupUsers,course,planningGroupTargetsWithValue.user.drlsWithValue,planningGroupTargetsWithValue.courseTarget.employee.drlsWithValue,targetRulesets.conditions'
        })
            .$promise
            .then((reloadedPlanningGroup) => {
                this.planningGroup = reloadedPlanningGroup;
                this.form.model.targets = reloadedPlanningGroup.planningGroupTargetsWithValue;
                this.loadDefaultTargets();
                this.loadExceptionTargets();
            });
    }

    loadDefaultTargets () {
        this.defaultTargets = this.form.model.targets.filter((target) => !target.employeeId);
    }

    loadExceptionTargets () {
        this.exceptionTargets = this.form.model.targets.filter((target) => target.userId);
    }

    loadCourseDefaultTargets (course) {
        const courseDefaultTargets = course.courseTargetsWithValue.filter((courseTarget) => !courseTarget.employeeId);

        const allDepartments = courseDefaultTargets.find((target) => target.departmentId === null);
        const allRoles = courseDefaultTargets.find((target) => target.roleId === null);
        const allLevels = courseDefaultTargets.find((target) => target.levelId === null);

        const classifierAllCondition = {};
        classifierAllCondition.types = [];

        if (allDepartments) {
            classifierAllCondition.types.push(this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        }
        else {
            this.departments = courseDefaultTargets
                .filter((target) => target.departmentId !== null)
                .map((target) => ({ id: target.departmentId, value: target.departmentName, type: this.CLASSIFIER_ENUM.KEYS.DEPARTMENT }));
        }

        if (allRoles) {
            classifierAllCondition.types.push(this.CLASSIFIER_ENUM.KEYS.ROLE);
        }
        else {
            this.roles = courseDefaultTargets
                .filter((target) => target.roleId !== null)
                .map((target) => ({ id: target.roleId, value: target.roleName, type: this.CLASSIFIER_ENUM.KEYS.ROLE }));
        }

        if (allLevels) {
            classifierAllCondition.types.push(this.CLASSIFIER_ENUM.KEYS.LEVEL);
        }
        else {
            this.levels = courseDefaultTargets
                .filter((target) => target.levelId !== null)
                .map((target) => ({ id: target.levelId, value: target.levelName, type: this.CLASSIFIER_ENUM.KEYS.LEVEL }));
        }

        if (classifierAllCondition.types.length > 0) {
            this.ClassifierResource.query({ 'types[]': classifierAllCondition.types })
                .$promise
                .then((classifiers) => {
                    if (!this.departments.length) {
                        this.departments = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
                    }

                    if (!this.roles.length) {
                        this.roles = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
                    }

                    if (!this.levels.length) {
                        this.levels = classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
                    }
                });
        }
    }

    loadCourseExceptionTargets (course) {
        this.courseExceptionTargets = course.courseTargetsWithValue.filter((courseTarget) => {
            return courseTarget.employeeId && courseTarget.type === this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM.KEYS.COMPULSORY;
        });
    }

    manageTarget (id) {
        const { departments, roles, levels, planningGroup } = this;

        return this.ModalService.open({
            size: id ? 'medium' : 'large',
            template: `
                <modals-planning-group-target-add
                    ng-if="!vm.targetId"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    planning-group="vm.planningGroup"
                />
                <modals-planning-group-target-edit
                    ng-if="vm.targetId"
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    planning-group="vm.planningGroup"
                    target-id="vm.targetId"
                />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.planningGroup = planningGroup;
                this.targetId = id;
            }
        }).then(() => this.reloadPlanningGroup());
    }

    addExceptionTarget () {
        const { departments, roles, levels, planningGroup, exceptionTargets, courseExceptionTargets } = this;

        return this.ModalService.open({
            size: 'large',
            template: `
                <modals-planning-group-target-exception-add
                    class="wrapper"
                    uib-modal-instance="vm.$uibModalInstance"
                    departments="vm.departments"
                    roles="vm.roles"
                    levels="vm.levels"
                    planning-group="vm.planningGroup"
                    exception-targets="vm.exceptionTargets"
                    course-exception-targets="vm.courseExceptionTargets"
                />
                `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.departments = departments;
                this.roles = roles;
                this.levels = levels;
                this.planningGroup = planningGroup;
                this.exceptionTargets = exceptionTargets;
                this.courseExceptionTargets = courseExceptionTargets;
            }
        }).then(() => this.reloadPlanningGroup());
    }

    removeTarget (targetId, isException = false) {
        let message = this.$translate.instant('planningGroup.confirm_before_deleting_target');
        if (isException) {
            message = this.$translate.instant('planningGroup.confirm_before_deleting_exception_target');
        }
        return this.ModalService.delete(message)
            .then(() => {
                this.form.model.targets = angular.copy(this.lodash.filter(this.form.model.targets, (target) => target.id !== targetId));
                this.form.save()
                    .then(() => {
                        this.toastr.success(this.$translate.instant('course.Target deleted'));
                        this.reloadPlanningGroup();
                    });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/steps/targets/list-deprecated/index.js